export const URL_S3 = "https://construcaribe.s3.amazonaws.com";
export const URL_BASE =
  process.env.REACT_APP_API_BASE_URL || "https://api.construcaribe.com";

export const DEFAULT_AVATAR_IMAGE = "/images/avatar.png";
export const DEFAULT_IMAGE = "/images/mockup.png";
